module.exports = __webpack_public_path__ + "static/media/Windmills_powering_tomorrow.d09be637.webp";